.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--hs-spacing-4);
}
.text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.label {
  font: var(--hs-type-label);
  letter-spacing: var(--hs-label-ls);
  color: var(--hs-color-text-primary);
}
.description {
  font: var(--hs-type-body-s);
  color: var(--hs-color-text-secondary);
}
.track {
  display: inline-flex;
  flex: none;
  align-items: center;
  width: var(--hs-toggle-width);
  height: var(--hs-toggle-height);
  padding: 2px;
  border: 0;
  border-radius: var(--hs-radius-full);
  background: var(--hs-color-border-default);
  cursor: pointer;
  transition: background-color 150ms ease;
}
.track[aria-checked='true'] {
  background: var(--hs-color-secondary-default);
}
.track:focus-visible {
  outline: none;
  box-shadow: var(--hs-focus-olive);
}
.track:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.knob {
  width: calc(var(--hs-toggle-height) - 4px);
  height: calc(var(--hs-toggle-height) - 4px);
  border-radius: var(--hs-radius-full);
  background: var(--hs-color-bg-surface);
  box-shadow: var(--hs-shadow-xs);
  transition: transform 150ms ease;
}
.track[aria-checked='true'] .knob {
  transform: translateX(calc(var(--hs-toggle-width) - var(--hs-toggle-height)));
}
